// extracted by mini-css-extract-plugin
export var art = "MysteryMultiHeader-module--art--16419";
export var header = "MysteryMultiHeader-module--header--7827a";
export var label = "MysteryMultiHeader-module--label--bfe8c";
export var level = "MysteryMultiHeader-module--level--4df05";
export var wordmark = "MysteryMultiHeader-module--wordmark--47708";